<template>
  <div class="crud_module--Select_weekday">
    <label class="label">{{ tran(k, col) }}</label>
    <SelectionFrom
        :view="false"
        :value="value"
        :closeable="true"
        :filterable="true"
        :multiple="true"
        @input="selected"
        :option="selectKey"
        :setup="{label:'name',value:'name'}"/>
  </div>
</template>

<script>
import SelectionFrom from '@/components/modules/SelectionFrom'

export default {
  components: {
    SelectionFrom,
  },
  props: ["data","col","k"],
  beforeMount() {
    if(this.data != undefined && this.data[this.col] != undefined){
        var arr = this.data[this.col].split(',');
        this.value = this.selectKey.filter(row=>arr.includes(row.name));
    }
  },
  methods: {
    selected(obj){
      var arr = [];
      for(var i in obj){
        arr.push(obj[i].name)
      }
      this.$emit("input", arr.join(','));
    },
    getDate (d){
        var y = d.getFullYear();
        var m = this.fill0(d.getMonth()+1);
        var d = this.fill0(d.getDate());
        return y+'-'+m+'-'+d
    },
    fill0(num){
        return num<10?'0'+num:num;
    }
  },
  computed:{
    selectKey(){
        var startDate = new Date();
        var dates = [];
        for(var i = 0;i<700;i++){
            var currentDate = new Date(
                startDate.getFullYear(),
                startDate.getMonth(),
                startDate.getDate() + i,
            );
            dates.push({name:this.getDate(currentDate)});
        }
        return dates;
    }
  },
  data() {
    return {
      value:undefined
    }
  }
}
</script>

<style lang="scss">
.crud_module--Select_weekday{
  
}
</style>